import { render, staticRenderFns } from "./AccountManager.vue?vue&type=template&id=4b83dc76&scoped=true"
import script from "./AccountManager.vue?vue&type=script&lang=ts"
export * from "./AccountManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83dc76",
  null
  
)

export default component.exports